import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductType } from '../../shared/models/auth-state.model';
import { AuthStateService } from '../../shared/services/auth-state.service';
import { BrandService } from '../../shared/services/brand.service';
import { LoginService } from '../../shared/services/login.service';
import { SsoAuthService } from '../services/sso-auth.service';

@Component({
  selector: 'app-sso-callback',
  templateUrl: './sso-callback.component.html',
  styleUrls: ['./sso-callback.component.scss'],
  standalone: false,
})
export class SsoCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ssoAuth: SsoAuthService,
    private loginService: LoginService,
    private destroyRef: DestroyRef,
    private authState: AuthStateService,
    private brandService: BrandService,
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');

    if (!code || !state) {
      this.router.navigate(['/login'], { replaceUrl: true });
      return;
    }

    this.ssoAuth
      .handleCallback(code, state)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ user }) => {
          sessionStorage.setItem('ssoSession', '1');
          this.loginService.setUser(user);
          const ctx = this.brandService.context;
          const resolvedDefaultCategoryId = ctx?.defaultCategoryId ?? null;
          this.authState.save({
            token: '',
            username: user.username,
            userId: user.id,
            roles: user.roles ?? [],
            productType: (user.productType as ProductType) ?? 'IR',
            brandId: ctx?.brandId ?? null,
            categories: ctx?.categories ?? [],
            defaultCategoryId: resolvedDefaultCategoryId,
            activeCategoryId: resolvedDefaultCategoryId,
          });
          this.router.navigate([this.brandService.current.homeRoute], { replaceUrl: true });
        },
        error: () => {
          this.router.navigate(['/login'], { replaceUrl: true });
        },
      });
  }
}
